import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import Cam from '../../assets/icons/Cam';
import Magnifier from '../../assets/icons/Magnifier';
import RightArrow from '../../assets/icons/RightArrow';
import { Menu, Dropdown } from 'antd';
import { useDebounce } from 'use-debounce';

import logo from '../../assets/images/logo.png';

import avi from '../../assets/images/boy-skin6.png';
import LiveClassDropdown from '../../components/Dropdown/LiveClassDropdown';
import SchoolCard from '../../components/SchoolCard/SchoolCard';
import SchoolSubjectCard from '../../components/LearnSubjectCard/SchoolSubjectCard';
import Spinner from '../../components/Spinner/Spinner';
import { baseURL } from '../../utils/axios';

const SearchResult = () => {
  const navigate = useNavigate();
  const [searchResult, setSearchResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const { topic, text } = useParams();

  const searchApp = async (selectedTopic, selectedText) => {
    let token = localStorage.getItem('token');

    try {
      setLoading(true);
      const res = await fetch(
        `${
          topic.toLowerCase() === 'all'
            ? `${baseURL}/search/${selectedText}`
            : topic.toLowerCase() === 'topic'
            ? `${baseURL}/search/${selectedText}?constraint=course`
            : `${baseURL}/search/${selectedText}?constraint=${selectedTopic?.toLowerCase()}`
        }`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json; charset=utf-8',
          },
        }
      );

      const data = await res.json();

      if (res.status === 200) {
        setSearchResult(data.data);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: 'Unable to get any result, please try again',
      });
      console.log(error);
    }
  };

  useEffect(() => {
    searchApp(topic, text);
  }, []);

  const [searchText, setSearchText] = useState(text);
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [debouncedText] = useDebounce(searchText, 1000);

  //handle search
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // if (debouncedText) {
  //   searchApp(selectedFilter, debouncedText);
  // }

  let userData = JSON.parse(localStorage.getItem('userData'));
  let schoolLogo = localStorage.getItem('schoolLogo');

  let notification = JSON.parse(localStorage.getItem('notification'));

  const menu = (
    <Menu placement='bottom'>
      <LiveClassDropdown />
    </Menu>
  );

  const filterMenuList = [
    { id: 1, item: 'All' },
    { id: 2, item: 'Topic' },
    { id: 3, item: 'School' },
    // { id: 4, item: 'Tutor' },
  ];

  const filterMenu = (
    <Menu placement='bottom'>
      <div className='filter-search'>
        {filterMenuList.map((el) => (
          <p
            className='filter-search__item'
            key={el.id}
            onClick={() => setSelectedFilter(el.item)}
          >
            {el.item}
          </p>
        ))}
      </div>
    </Menu>
  );

  const goBack = (e) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      navigate(-1);
    }
  };

  return (
    <>
      <div className='dashboard-header'>
        <div className='dashboard-header__logo' onClick={() => navigate('/')}>
          <img src={logo} alt='' />
        </div>

        <div className='dashboard-header__search'>
          <Dropdown overlay={filterMenu} trigger={['click']}>
            <div
              className='dashboard-header__search__filter'
              style={{ cursor: 'pointer' }}
            >
              <Magnifier />
              <p className='dashboard-header__search__filter__text'>
                {selectedFilter}
              </p>

              <RightArrow />
            </div>
          </Dropdown>
          <input
            type='search'
            placeholder='Search for anything'
            value={searchText}
            onKeyDown={(e) => goBack(e)}
            onChange={(e) => onFilterChange(e)}
          />
        </div>

        <div className='dashboard-header__profile'>
          <Dropdown overlay={menu} trigger={['click']}>
            <div style={{ cursor: 'pointer' }}>
              {notification && <div className='red-dot'></div>}
              <Cam />
            </div>
          </Dropdown>

          <div
            className='dashboard-header__profile__image'
            onClick={() => navigate('/profile')}
          >
            <img
              src={
                userData?.avatar || schoolLogo || userData?.school?.logo || avi
              }
              alt=''
            />
          </div>
        </div>
      </div>
      <div className='search-results'>
        <div
          className='search-results__breadcrumbs'
          style={{ color: '#161410' }}
        >
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
              fill='#161410'
            />
          </svg>
          <p>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => window.history.back()}
            >
              Home{' '}
            </span>
            | Search result for “{text || debouncedText}”
          </p>
        </div>
        {loading && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spinner />
          </div>
        )}
        {searchResult?.schools && searchResult?.schools !== 'No data found' ? (
          <div className='search-results__results-wrapper'>
            <div className='search-results__title'>
              <h2>
                {' '}
                {searchResult?.schools?.length} result for “
                {text || debouncedText}” in Schools
              </h2>
            </div>
            <div className='courses'>
              {searchResult?.schools?.map((el) => (
                <SchoolCard
                  key={el.id}
                  schoolLogo={el.logo}
                  schoolHeader={el.logo}
                  schoolName={el.name}
                  subjectNo={el.subject_classes_count}
                  description={el.bio}
                  activities={el.activity_count}
                  location={`${el.state}, ${el.country}` || 'Lagos,Nigeria'}
                  lessonCount={el.lessons_count}
                  selectSchool={() => {
                    navigate(`/schools/${el.id}`);
                  }}
                  page='dashboard'
                  type='school'
                />
              ))}
            </div>
          </div>
        ) : (
          <div className='search-results__title'>
            <h2> No result for “{text || debouncedText}” in Schools</h2>
          </div>
        )}

        {searchResult?.courses && searchResult?.courses !== 'No data found' ? (
          <div className='search-results__results-wrapper'>
            <div className='search-results__title'>
              <h2>
                {' '}
                {searchResult?.courses?.length} result for “
                {text || debouncedText}” in Courses
              </h2>
            </div>
            <div className='courses'>
              {searchResult?.courses?.map((el, index) => (
                <SchoolSubjectCard
                  key={el.id}
                  index={index}
                  schoolHeader={
                    el?.title?.toLowerCase()?.includes('biology')
                      ? 'http://images.shiksha.com/mediadata/images/articles/1538985491phpKctLgx.jpeg'
                      : el?.title?.toLowerCase()?.includes('mathematics')
                      ? 'https://leverageedu.com/blog/wp-content/uploads/2020/07/Branches-of-Mathematics.png'
                      : el?.title?.toLowerCase()?.includes('english')
                      ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrP9mK3dTuXB86woJ2JW7J8TkxszYhRVk_4Q&usqp=CAU'
                      : el.banner
                  }
                  price={el?.price || 'N/A'}
                  id={el?.id || 'N/A'}
                  subject={el?.name || 'N/A'}
                  description={el?.description || 'No description available'}
                  topic={el?.title || 'N/A'}
                  duration={el?.duration || 'N/A'}
                  lessonStyle={el?.lesson_style || 'N/A'}
                  lessonCount={el?.lessons?.length || 'N/A'}
                  currency={el?.currency?.symbol || 'N/A'}
                  subjectClass={el?.title || 'N/A'}
                  // selectSchool={() => {
                  //   if (sCart?.some((item) => item.id === el.id)) {
                  //     notification['error']({
                  //       message: 'Item already exists in cart',
                  //     });
                  //   } else {
                  //     setCart([...cart, el]);
                  //     localStorage.setItem(
                  //       'cart',
                  //       JSON.stringify([...cart, { ...el, school }])
                  //     );
                  //   }
                  // }}
                  page='dashboard'
                />
              ))}
            </div>
          </div>
        ) : (
          <div className='search-results__title'>
            <h2> No result for “{text || debouncedText}” in Courses</h2>
          </div>
        )}

        {/* {searchResult?.tutors && searchResult?.tutors !== 'No data found' ? (
          <div className='search-results__results-wrapper'>
            <div className='search-results__title'>
              <h2>
                {' '}
                {searchResult?.tutors?.length} result for “{text}” in Tutors
              </h2>
            </div>
            <div className='courses'>
              {searchResult?.tutors?.map((el) => (
                <SubjectCard
                  key={el.id}
                  id={el.id}
                  subject={el.name}
                  description={el.description}
                  subjectHeader={el.banner}
                  selectSubject={() => {
                    navigate(`/subjects/${el.id}`);
                  }}
                  type='dashboard'
                />
              ))}
            </div>
          </div>
        ) : (
          <div className='search-results__title'>
            <h2> No result for “{text}” in Tutors</h2>
          </div>
        )} */}
      </div>
    </>
  );
};

export default SearchResult;
